import styled from "styled-components";

export const HeadingWrapper = styled.div`
  position: relative;
  .right-arrow {
    position: absolute;
    left: -33px;
    top: 0;
  }
  @media (max-width: 767px) {
    h6 {
      font-size: 20px !important;
      line-height: 36px !important;
      padding-left: 48px !important;
    }
    .right-arrow {
      max-width: 71px;
    }
  }
`;
export const SectionWrapper = styled.div`
  border-radius: 10px;
  padding: 0 33px;
  margin-bottom: 20px;
  color: #191819;
  background: #fff;
  box-shadow: 0 2px 10px 0 #00000029;  
  .checkbox-wrapper{
    .checkbox-field {
      margin: 13px 0!important;
    }
  } 
  .office-days{
    .checkbox-field {
      margin: 10px 13px 0px 0px !important;
    }
  }
  .select-height {
    min-height: 97px;
  }
  .mb-7 {
    margin-bottom: 7px;
  }
  p {
    font-size: 17px;
    font-family: "latoregular";
  }
  .disable-date-picker-style .file-input-wrapper .MuiFormControl-root{
    background: #f2f2f2;
  }
  .app-input-text{
    margin-bottom: 0px !important;
  }
`;

export const FormWrapper = styled.div`
  display: flex;

`
export const BlankSection = styled.div`
  flex: 1;
  max-width: 253px;
  min-width: 253px;
  @media (max-width: 1250px) {
    display: none;
  }
  `
export const FormDiv = styled.div`
  flex: 1;
  padding-left: 29px;
  @media (max-width: 1250px) {
    padding-left: 0;
  }
`;

export const PostLoaduploadWrapper = styled.div`
    p.error-message-multiple {
      position: unset;
    color: red !important;
    font-style: italic;
    font-size: 12px !important;
    margin-top: 10px;

    }
`
export const UploadSpec = styled.div`    
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: flex-start;
    span {
      white-space: normal;
    margin-top: 2px;
    }
    img {
      margin-right: 5px;
    }
`
export const CheckBoxWrapper = styled.div`
  display: flex;
  align-items:flex-end ;
  .checkbox-field {
    // margin-bottom: 6px;
    margin: 14px 0 6px 0!important;
  }
  .i-icon {
    bottom: 9px;
  }
  .web-only {
    display: block;
  }
  @media (max-width:768px) {
    .web-only {
    display: none;
    }
  }
`

export const PalletSpecWrapper = styled.div`
  .app-input-text{
    margin-bottom: 0px !important;
  }
`